export const role_path_variable = "role"

export const base_api_uri = `/api`
export const authenticate_uri = `${base_api_uri}/authenticate`
export const base_user_uri = `${base_api_uri}/user`
export const base_token_uri = `${base_api_uri}/download/token`
export const current_user_uri = `${base_user_uri}/current`
export const patients_uri = `${base_user_uri}/patients`
export const doctors_uri = `${base_user_uri}/doctors`
export const admins_uri = `${base_user_uri}/administrators`
export const by_role_uri = (role) => `${base_user_uri}/role/${role}`
export const by_name_uri = (username) => `${base_user_uri}/${username}`

export const base_doctor_uri = `${base_api_uri}/doctor`
export const patients_for_doctors = `${base_doctor_uri}/patients`
export const patients_details = (username) => `${patients_for_doctors}/${username}`
export const create_session = (username) => `${patients_details(username)}/session`
export const active_session_uri = `${base_doctor_uri}/session`
export const base_session_uri = (sessionId) => `${base_doctor_uri}/session/${sessionId}`
export const medical_info_uri = (sessionId) => `${base_session_uri(sessionId)}/medical_info`
export const preferences_uri = (sessionId) => `${base_session_uri(sessionId)}/preferences`
export const save_session_progress_uri = (sessionId) => `${base_session_uri(sessionId)}/log`
export const save_decision_uri = (sessionId) => `${base_session_uri(sessionId)}/decision`
